import { render } from "./JoyDataTable.vue?vue&type=template&id=6289f629"
const script = {}

import "./JoyDataTable.vue?vue&type=style&index=0&id=6289f629&lang=scss"

import exportComponent from "/tmpfs/builds/maltcommunity/malt/apps/malt/node_modules/.pnpm/vue-loader@17.0.1_p6ywf2fz4v3oextcdrklqlunue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__